import { sendMetaEvent } from '../api/ceremony';

export const _sendMetaEvent = (eventName: string, eventData?: any) => {
  try {
    sendMetaEvent(eventName, eventData);
  } catch (error) {
    console.log(error);
  }
};
